module.exports = __webpack_public_path__ + "img/SCweatherNew.d07da19a.png";